module.exports = __webpack_public_path__ + "5fcc09e41a7ca39be3f1835f8325e3c7.pdf";